export default __webpack_public_path__ + "static/sortiment-sustenabil-1e77a8d37478085252ae91e3460e0b5b.jpg";